import { DefaultUrlSerializer, UrlSerializer, UrlTree } from '@angular/router';

export class CaseInsensitiveUrlSerializer extends DefaultUrlSerializer {
  parse(url: string): UrlTree {
    return super.parse(url.toLowerCase());
  }

  serialize(tree: UrlTree): string {
    return super.serialize(tree).toLowerCase();
  }
}
